import React, { useCallback, useMemo } from 'react';
import { FlashList } from '@shopify/flash-list';
import { FlatList, View } from 'react-native';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { useSortBySelector } from 'design-system/SortBySelector/useSortBySelector';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import createStyleSheets from 'utils/createStyleSheets';
import { selectFilteredUserTags } from 'features/transactions/selectors';
import EmptyComponent from './KeyboardEmpty';
import KeyboardTagsRow from './KeyboardTagsRow';
import { isDesktopOrWeb, isWeb } from '../../../../constants';
const keyExtractor = (item) => item.label;
const strings = {
    empty: 'There are no tags available in any of your transactions',
};
const KeyboardTags = ({ onSelect, activeFilters, settingsFilter, contentContainerStyle }) => {
    const { sortMethod, Button } = useSortBySelector('Transaction');
    const data = useAppSelector((state) => selectFilteredUserTags(state, sortMethod));
    const activeFilterMap = useMemo(() => activeFilters?.reduce((acc, curr) => {
        acc[curr.label] = true;
        return acc;
    }, {}), [activeFilters]);
    const type = useMemo(() => (settingsFilter === 'AND' ? 'single' : 'multiple'), [settingsFilter]);
    const renderItem = useCallback(({ item }) => (<KeyboardTagsRow item={item} type={type} isSelected={activeFilterMap?.[item.label]} onPress={() => {
            onSelect('KeyboardTags', {
                ...item,
                badgeText: `#${item.label}`,
                filterType: 'TAG',
            });
        }}/>), [activeFilterMap, onSelect, type]);
    const styles = useStyles(styleSet);
    const flatListStyles = useMarginBottom('paddingBottom', undefined, contentContainerStyle);
    const Content = useMemo(() => {
        const baseProps = {
            data,
            renderItem,
            keyExtractor,
            style: styles.flatList,
            contentContainerStyle: flatListStyles,
            ListEmptyComponent: <EmptyComponent description={strings.empty}/>,
        };
        if (isWeb) {
            return <FlatList {...baseProps}/>;
        }
        return <FlashList {...baseProps} extraData={[activeFilterMap, onSelect]}/>;
    }, [activeFilterMap, data, flatListStyles, onSelect, renderItem, styles.flatList]);
    return (<>
      <View style={contentContainerStyle}>
        <SectionHeader horizontalMargins style={styles.sectionHeader} button={Button}>
          Tags
        </SectionHeader>
      </View>
      {Content}
    </>);
};
const styleSet = createStyleSheets(() => ({
    flatList: {
        ...(isDesktopOrWeb && {
            padding: 8,
        }),
    },
    sectionHeader: {
        paddingTop: rem(12),
    },
}));
export default KeyboardTags;
